import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@excalidraw/excalidraw/index.css';
// Shared editor styles first (estimate panel, catalog editors); the board's own CSS wins.
import '@redline/shared/styles.css';
import './styles.css';
import { App } from './App';

// Self-hosted Excalidraw fonts (vite.config.ts copies them to /fonts/).
(window as unknown as { EXCALIDRAW_ASSET_PATH?: string }).EXCALIDRAW_ASSET_PATH = new URL(import.meta.env.BASE_URL, location.origin).href;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
